<template>

    <modal @closeModal="closeModal" :show="showModal">

        <div class="my-actions-modal-container">

            <img class="confirm-my-actions-icon" src="/img/icons/action-back-blue-white.svg">

            <p v-if="type === 'unblock'" class="my-actions-modal-text">{{ $tc('pop_up_rollback_autodelete_description', this.arrayItems.length) }}</p>

            <p v-else class="my-actions-modal-text">{{ $tc('pop_up_rollback_keep_description', this.arrayItems.length) }}</p>

            <button class="btn btn-blue btn-1" @click="accept">

                <lottie-loader v-if="loading" :size="20"></lottie-loader>

                <span v-else class="btn-1-text">{{ $t('pop_up_rollback_autodelete_cta_confirm') }}</span>

            </button>

            <button class="btn btn-grey btn-2 margin-btn" @click="closeModal">

                <span class="btn-2-text">{{ $t('settings_cta_cancel_delete') }}</span>

            </button>

        </div>

    </modal>

</template>

<script>

import Api from '@/api'

import Tag from '@/modules/tag'

import Checkbox from '@/components/inputs/Checkbox'
import LottieLoader from '@/components/lottie/LottieLoader'
import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-my-actions',

    components: { Checkbox, LottieLoader, Modal },

    data () {
        return {
            showModal: false,
            arrayItems: [],
            loading: false,
            type: ''
        }
    },

    methods: {

        open (arrayItems, type) {

            this.loading = false

            this.showModal = true

            this.arrayItems = arrayItems

            this.type = type

            type === 'unblock' ? Tag.popupAmplitude(this, 'pop_up_rollback_autodelete') : Tag.popupAmplitude(this, 'pop_up_rollback_keep')
        },

        closeModal (bool) {
            this.showModal = false
            Tag.clickAmplitude(this, 'cancel')
            this.$emit('close', bool)
        },

        accept () {

            this.loading = true

            if (this.type === 'unblock') {

                Tag.clickAmplitude(this, 'rollback_autodelete')

                Api.newsletters.unblock(this.arrayItems)
                    .then(data => {
                        this.closeModal(data.done)
                    })
                    .catch(() => {
                        this.closeModal(false)
                    })
                    .finally(() => {
                        this.loading = false
                    })

            } else {

                Tag.clickAmplitude(this, 'rollback_keep')

                Api.newsletters.release(this.arrayItems)
                    .then(data => {
                        this.closeModal(data.done)
                    })
                    .catch(() => {
                        this.closeModal(false)
                    })
                    .finally(() => {
                        this.loading = false
                    })

            }

        }

    }

}

</script>

<style scoped lang="scss">

    .my-actions-modal-container {
        padding: 24px 16px 16px;
        max-width: 501px;
    }

    .confirm-my-actions-icon {
        width: 48px;
        object-fit: contain;
    }

    .my-actions-modal-text {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.25;
        color: $secur-text;
        margin: 16px 0;
    }

    .margin-btn {
        margin-top: 8px;
    }

    .btn-1 {
        height: 48px;
    }

    .btn-2 {
        height: 40px;
    }

    .btn-1-text {
        font-size: 14px;
        font-weight: bold;
        color: $white;
    }

    .btn-2-text {
        font-size: 14px;
        font-weight: bold;
        color: $grey;
    }

</style>
